import { PREMIUM_APP_THEME } from './premium.theme.js';
import { CLASSIC_APP_THEME } from './classic.theme.js';
export const DEFAULT_APP_THEME_ID = 'premium';
const THEMES = [PREMIUM_APP_THEME, CLASSIC_APP_THEME];
const byId = new Map(THEMES.map((t) => [t.id, t]));
export function listAppThemes() {
    return THEMES;
}
export function getAppTheme(themeId) {
    if (themeId && byId.has(themeId))
        return byId.get(themeId);
    return byId.get(DEFAULT_APP_THEME_ID);
}
export function isAppThemeId(value) {
    return byId.has(value);
}
export function resolveAppThemeId(themeId) {
    return isAppThemeId(themeId ?? '') ? themeId : DEFAULT_APP_THEME_ID;
}
//# sourceMappingURL=registry.js.map